/**
 * Node shape passed to the attack path tooltip by the findings MFE (G6 node model).
 * Used for AssetHeader and AssetActionInstruction in search.
 */
export interface SearchAttackPathNode {
  id?: string;
  label?: string;
  data?: { type?: string };
  graphProps?: {
    id?: string;
    name?: string;
    type?: string;
    assetType?: string;
    [key: string]: unknown;
  };
  subLabel?: string;
  meta?: { overflowOf?: string; hiddenCount?: number; [key: string]: unknown };
  [key: string]: unknown;
}

/** The "+N more" node the findings graph adds when a group is cut short. */
export const isOverflowNode = (node: SearchAttackPathNode) =>
  node.data?.type === 'overflow';
